<!-- eslint-disable max-len -->
<template>
  <div class="component-card">
    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="clickDetail">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="createData">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <j-import-file-oos
            v-if="openImport && !readOnly"
            :href-sample="require('@/assets/file/FORMAT_IMPORT_MASTER_PELANGGARAN.zip')"
            class="import-style"
            @import-data="importData"/>
          <div class="cc-btn">
            <b-button
              v-if="is_error"
              class="btn outline red"
              @click="$refs.editPelanggaran.show()">
              <i class="fa fa-close"/>
              Open Error Data
            </b-button>
            <!-- <b-button
              v-else-if="data_import && !is_error"
              class="btn green outline"
              @click="uploadData">
              Import Data
            </b-button> -->
          </div>
        </b-form>
      </div>
    </v-server-table>
    <jLoadingTable v-if="show_table && !load_first"/>

    <b-modal
      ref="modalPelanggaran"
      class="mod-form modal-tahun-ajaran"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <div class="title-bold ql-align-center">{{ data_master.id ? 'Rubah' : 'Tambah' }} Pelanggaran</div>

      <b-form-group :class="{'error-input' : $v.data_master.nama.$error}">
        <label> Nama </label>
        <j-input
          v-model="$v.data_master.nama.$model"
          :disabled="readOnly"
          placeholder="Nama"/>
      </b-form-group>

      <b-form-group :class="{'error-input' : $v.data_master.point.$error}">
        <label> Poin (-) </label>
        <j-input
          v-model="$v.data_master.point.$model"
          :disabled="readOnly"
          placeholder="Poin (-)"
          type="number"/>
      </b-form-group>

      <b-row>
        <b-col md="4">
          <b-button
            v-if="data_master.id && !readOnly"
            class="btn red"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="8">
          <div class="float-to-right">
            <b-button
              class="btn gray"
              @click="closeData">
              Cancel
            </b-button>
            <b-button
              v-if="!readOnly"
              class="btn blue m__l--5"
              @click="saveData">
              {{ data_master.id ? 'Update' : 'Save' }}
            </b-button>
          </div>
        </b-col>
      </b-row>

    </b-modal>

    <j-progress-screen
      ref="ImportFile"
      :data-kirim="data_import"
      :url-api="url"
      :headers="headers"
      @finish="reloadPage"/>

    <b-modal
      ref="editPelanggaran"
      class="mod-form"
      centered>
      <h3 class="float-to-center c--red">
        Error Data
      </h3>
      <v-client-table
        v-if="error_data[0]"
        :data="error_data"
        :columns="columns"
        :options="options"
        class="jTable">

        <div
          slot="ERROR"
          slot-scope="props">
          <div
            v-for="(err, index) in props.row.ERROR"
            :key="index">
            {{ err }}
          </div>
        </div>

      </v-client-table>
      <download-excel
        :data="error_data"
        class="float-to-right m__t--30"
        name="data-error.xls">
        <b-button class="btn green">
          Export Error
        </b-button>
      </download-excel>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import Vue from 'vue';
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKesiswaan from '@/services/jApiKesiswaan';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jProgressScreen from '@/components/progress-screen/jProgressScreen';

export default {
  components: {
    jLoadingTable,
    jProgressScreen,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      data_master: {
        nama: '',
        point: 0,
      },
      load_first: false,
      data_table: [],
      columns: ['id', 'nama', 'point'],
      options: {
        headings: {
          id: 'ID',
          nama: 'NAMA PELANGGARAN',
          point: 'POINT',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 1000,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
          };
        },
        requestFunction(data) {
          const getList = jApiKesiswaan.listPelanggaran();
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      openImport: true,
      data_import: null,
      list_error: [],
      error_data: [],
      is_error: false,
    };
  },
  computed: {
    url() {
      const getEnv = 'pelanggaran/create';
      return getEnv;
    },
    headers() {
      const token = Vue.ls.get('Token');
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      return headers;
    },
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.tableServer.setFilter('');
      }
    },
  },
  created() {
    this.listTahunAjaran();
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKesiswaan', ['createPelanggaran', 'updatePelanggaran', 'deletePelanggaran']),

    loading(val) {
      const a = val;
      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;
      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.tableServer.getData();
    },

    filter(val) {
      this.$refs.tableServer.setFilter(val);
    },

    createData() {
      this.$refs.modalPelanggaran.show();
    },

    closeData() {
      this.$refs.modalPelanggaran.hide();
      this.data_master = {
        nama: '',
        point: 0,
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        const params = this.data_master;
        const action = this.data_master.id ? 'updatePelanggaran' : 'createPelanggaran';
        this[action](params).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeData();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deletePelanggaran(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeData();
              }, 1500);
            }
          });
        }
      });
    },

    clickDetail({ row }) {
      this.$refs.modalPelanggaran.show();
      this.data_master = {
        id: row.id,
        nama: row.nama,
        point: row.point,
      };
    },

    importData(val) {
      const keys = Object.keys(val[0]);
      if (keys[0] !== 'NAMA' || keys[1] !== 'POINT') {
        this.toggleProblem('Please use header format correctly');
      }
      this.is_error = false;
      this.list_error = [];
      this.error_data = val;
      const fileData = val;
      const genData = [];
      fileData.forEach((e, index) => {
        const ccData = this.convertData(e, index);
        if (ccData !== false) {
          genData.push(ccData);
        }
      });
      this.data_import = genData;

      setTimeout(() => {
        if (this.data_import && !this.is_error) {
          this.$refs.ImportFile.toggleIsVisible();
        }
      }, 1000);
    },

    convertData(val, indexData) {
      this.list_error[indexData] = [];
      this.error_data[indexData].ERROR = [];
      const packing = {
        nama: val.NAMA,
        point: val.POINT,
      };
      if (!val.NAMA) {
        this.is_error = true;
        this.list_error[indexData].push('NAMA tidak boleh kosong');
        this.error_data[indexData].ERROR.push('NAMA tidak boleh kosong');
      }
      if (!val.POINT) {
        this.is_error = true;
        this.list_error[indexData].push('POINT tidak boleh kosong');
        this.error_data[indexData].ERROR.push('POINT tidak boleh kosong');
      }
      return packing;
    },

    uploadData() {
      this.$refs.ImportFile.toggleIsVisible();
    },

    reloadPage() {
      this.$refs.tableServer.getData();
      this.openImport = false;
      this.data_import = null;
      this.list_error = [];
      this.error_data = [];
      this.is_error = false;
      setTimeout(() => {
        this.openImport = true;
      }, 500);
    },
  },
  validations() {
    return {
      data_master: {
        nama: { required },
        point: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kesiswaan/pelanggaran/jPelanggaran.vue